export const TOOLTIP_NO_OFFER_TEXT = 'Нет подходящих предложений';

export const COMMON_VILLAGES_PATH = '/kottedzhnye-poselki/';
export const SEO_VILLAGES_PATH = '/kottedzhnye-poselki-*';
